import { defineMessages } from "react-intl"

export default defineMessages({
  personal: {
    defaultMessage: "Personal",
    id: "src.pages.HomePage.personal",
  },
  switchingMessage: {
    defaultMessage: "Switching to {profileType} account...",
    id: "src.pages.HomePage.switchingMessage",
  },
})
